import React from 'react';

import type { Props } from './types';

const CalendarQuestion: React.FC<Props> = ({ className }) => (
  <svg
    data-prefix="fas"
    data-icon="calendar-question"
    className={`svg-inline--fa ${className ?? ''}`}
    role="img"
    viewBox="0 0 448 512"
    aria-hidden="true">
    <path
      fill="currentColor"
      d="M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32z"
    />
    <path
      d="M178 220 C178 185 270 185 270 230 C270 260 224 260 224 300"
      fill="none"
      stroke="white"
      strokeWidth="52"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="224" cy="368" r="26" fill="white" />
  </svg>
);

export default CalendarQuestion;
